export const META_MANAGEMENT_PATH = '/meta-management';

/** List 탭 경로입니다. 기존 진입 URL 은 이 경로로 리다이렉트됩니다. */
export const META_MANAGEMENT_LIST_PATH = `${META_MANAGEMENT_PATH}/list`;

/** Dashboard 탭 경로입니다. */
export const META_MANAGEMENT_DASHBOARD_PATH = `${META_MANAGEMENT_PATH}/dashboard`;

export enum META_DATA_SCENE {
  NONE = 'None',
  ALLEY = 'Alley',
  HIGHWAY = 'Highway',
  INDOOR = 'Indoor',
  INTERSECTION = 'Intersection',
  OFFICE = 'Office',
  PLAZA = 'Plaza',
  SIMULATION = 'Simulation',
  SQUARE = 'Square',
  URBAN = 'Urban',
  PARKING_LOT = 'ParkingLot',
  CONSTRUCTION = 'Construction',
  PROVING_GROUND = 'ProvingGround',
}

export enum META_DATA_WEATHER {
  SUNNY = 'Sunny',
  RAIN = 'Rain',
  SNOW = 'Snow',
  FOG = 'Fog',
  HARD_RAIN = 'HardRain',
  HARD_SNOW = 'HardSnow',
}

export enum META_DATA_SOLUTION {
  PROSPECTOR = 'prospector',
  VUE_ONE = 'vueone',
  VUE_TWO = 'vuetwo',
}

export enum META_DATA_ETC_DEVICE {
  RADAR = 'Radar',
  GPS = 'GPS',
  WEBCAM = 'Webcam',
  IPCAM = 'IPcam',
}

export const META_MANAGEMENT_SCENE_OPTION_LIST = [
  { i18nKey: 'metaManagement.scene.none', value: META_DATA_SCENE.NONE },
  { i18nKey: 'metaManagement.scene.alley', value: META_DATA_SCENE.ALLEY },
  {
    i18nKey: 'metaManagement.scene.highway',
    value: META_DATA_SCENE.HIGHWAY,
  },
  {
    i18nKey: 'metaManagement.scene.indoor',
    value: META_DATA_SCENE.INDOOR,
  },
  {
    i18nKey: 'metaManagement.scene.intersection',
    value: META_DATA_SCENE.INTERSECTION,
  },
  {
    i18nKey: 'metaManagement.scene.office',
    value: META_DATA_SCENE.OFFICE,
  },
  { i18nKey: 'metaManagement.scene.plaza', value: META_DATA_SCENE.PLAZA },
  {
    i18nKey: 'metaManagement.scene.simulation',
    value: META_DATA_SCENE.SIMULATION,
  },
  {
    i18nKey: 'metaManagement.scene.square',
    value: META_DATA_SCENE.SQUARE,
  },
  { i18nKey: 'metaManagement.scene.urban', value: META_DATA_SCENE.URBAN },
  {
    i18nKey: 'metaManagement.scene.parkingLot',
    value: META_DATA_SCENE.PARKING_LOT,
  },
  {
    i18nKey: 'metaManagement.scene.construction',
    value: META_DATA_SCENE.CONSTRUCTION,
  },
  {
    i18nKey: 'metaManagement.scene.provingGround',
    value: META_DATA_SCENE.PROVING_GROUND,
  },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: META_DATA_SCENE;
}>;

export const META_MANAGEMENT_WEATHER_OPTION_LIST = [
  {
    i18nKey: 'metaManagement.weather.sunny',
    value: META_DATA_WEATHER.SUNNY,
  },
  { i18nKey: 'metaManagement.weather.rain', value: META_DATA_WEATHER.RAIN },
  { i18nKey: 'metaManagement.weather.snow', value: META_DATA_WEATHER.SNOW },
  { i18nKey: 'metaManagement.weather.fog', value: META_DATA_WEATHER.FOG },
  {
    i18nKey: 'metaManagement.weather.hardRain',
    value: META_DATA_WEATHER.HARD_RAIN,
  },
  {
    i18nKey: 'metaManagement.weather.hardSnow',
    value: META_DATA_WEATHER.HARD_SNOW,
  },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: META_DATA_WEATHER;
}>;

export const META_MANAGEMENT_SOLUTION_OPTION_LIST = [
  {
    i18nKey: 'metaManagement.solution.prospector',
    value: META_DATA_SOLUTION.PROSPECTOR,
  },
  {
    i18nKey: 'metaManagement.solution.vueOne',
    value: META_DATA_SOLUTION.VUE_ONE,
  },
  {
    i18nKey: 'metaManagement.solution.vueTwo',
    value: META_DATA_SOLUTION.VUE_TWO,
  },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: META_DATA_SOLUTION;
}>;

export const META_MANAGEMENT_ETC_DEVICE_OPTION_LIST = [
  { i18nKey: 'metaManagement.device.radar', value: META_DATA_ETC_DEVICE.RADAR },
  { i18nKey: 'metaManagement.device.gps', value: META_DATA_ETC_DEVICE.GPS },
  {
    i18nKey: 'metaManagement.device.webcam',
    value: META_DATA_ETC_DEVICE.WEBCAM,
  },
  { i18nKey: 'metaManagement.device.ipcam', value: META_DATA_ETC_DEVICE.IPCAM },
] as const satisfies ReadonlyArray<{
  i18nKey: string;
  value: META_DATA_ETC_DEVICE;
}>;
